import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-menu-rio-container',
  template: `<app-menu-rio></app-menu-rio>`,
  styleUrls: ['./menu-rio-container.component.css']
})
export class MenuRioContainerComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit(): void {}
}
